// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"760f7b16","453":"427d0bc0","796":"3fe012aa"}[chunkId] + ".chunk.js";
};